module.exports = __webpack_public_path__ + "static/media/rounds_back.b7aee40d.svg";